import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import HddFilledSvg from "@ant-design/icons-svg/es/asn/HddFilled";
import AntdIcon from "../components/AntdIcon";
var HddFilled = function HddFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HddFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  HddFilled.displayName = 'HddFilled';
}
export default /*#__PURE__*/React.forwardRef(HddFilled);